// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"f9657dc7","124":"5d841113","185":"6de721c2","243":"0aeb5213","353":"a6ae83c4","453":"87e45203","660":"dff304d2","666":"d7203a29","697":"31498dcd","712":"e5c02456","720":"52f5782b","819":"1e839109","855":"eae4d548"}[chunkId] + ".chunk.js";
};